import { createFileRoute } from '@tanstack/react-router';

import { HiringRequestsPage } from '@/features/talent/hiring-requests-page';

export const Route = createFileRoute('/_app/marketplace/workers/requests')({
  component: HiringRequestsPage,
});
